<template>
    <div class="input-wrapper">
        <ValidationProvider :rules="rules" ref="number-input" v-slot="v" :vid="vid">
            <div class="flex justify-between relative mb-3">
                <div v-if="label || subtext || v.errors.length || errorMessage">
                    <label class="label" v-if="label" :for="name">
                        {{ label }}
                        <span v-if="rules.includes('optional')" class="mr-2"></span>
                        <span v-if="rules.includes('optional')" class="opacity-40">(Optional)</span>
                    </label>
                    <p v-if="subtext" class="subtext">{{ subtext }}</p>
                </div>
                <div v-if="hint">
                    <HintComponent :hint="hint" />
                </div>
            </div>
            <div class="input-container relative">
                <input
                    :disabled="disabled"
                    v-model="content"
                    :name="name"
                    type="text"
                    :placeholder="placeholder"
                    :autocomplete="autocomplete"
                    :class="[
                        v.errors.length || errorMessage ? 'has-errors' : '',
                        disabled ? 'disabled:opacity-60' : '',
                        classNames ? classNames : '',
                    ]"
                    @keydown="updateValue"
                />
                <div class="absolute right-0 top-0 pr-2 flex flex-col">
                    <button
                        @click="updateValue({}, 'increment')"
                        class="icon-chevron hover:text-green rotate-180 p-1"
                        aria-label="Increment"
                    ></button>
                    <button
                        @click="updateValue({}, 'decrement')"
                        class="icon-chevron hover:text-green p-1"
                        aria-label="Decrement"
                    ></button>
                </div>
                <div
                    class="input-status mt-1 mr-8"
                    v-if="showSuccessStatus && v.valid && !errorMessage && !rules.includes('optional')"
                >
                    <lottie-animation
                        :width="41"
                        :height="41"
                        :loop="false"
                        :path="global.app.path + 'animations/success-tick-circle.json'"
                    />
                </div>
                <p v-if="v.errors.length || errorMessage" class="!opacity-100 subtext text-error">
                    {{ errorMessage ? errorMessage : v.errors[0] }}
                </p>
            </div>
        </ValidationProvider>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { ValidationProvider } from "vee-validate";
import HintComponent from "@components/misc/HintComponent";

export default {
    name: "InputComponent",
    props: {
        type: { type: String, default: "text" }, // Accepting a "type" property and setting the type of value accepted along with a default value
        name: { type: String, default: "" }, // "Name" prop for naming the input
        value: { default: "" }, // "Value" prop for setting an initial value for the input
        label: { type: String, default: "" }, // Label used for the input
        placeholder: { type: String, default: "" }, // The input's placeholder text
        hint: { type: String, default: "" }, // For the little "?" that appears with a hint for the specific input field
        subtext: { type: String, default: "" }, // The small subtext shown below the label and above the input
        rules: { type: String, default: "required|positive" }, // The validation rules set on the input. See VeeValidate for available rules
        vid: { type: String, default: "" }, // Used for VeeValidate
        autocomplete: { type: String, default: "" }, // Used for the autocomplete HTML attribute
        showSuccessStatus: { type: Boolean, default: true },
        error: { type: String, default: "" }, // Used to set a specific error from the response from the backend/API
        disabled: { type: Boolean, default: false }, // Used to set the input to a "disabled" state
        classNames: { type: String, default: "" }, // Using custom component variable due to reserved naming issues of "class"
        step: { type: Number, default: 1 },
    },
    components: {
        ValidationProvider,
        HintComponent,
    },
    computed: {
        ...mapGetters(["global"]),
    },
    data: function () {
        return {
            content: this.value,
            errorMessage: this.error,
        };
    },
    methods: {
        /**
         * Updates the value based on the user input event
         * @param {Event} event - The input event triggering the update
         */
        updateValue(event, operator = "") {
            if (isNaN(parseInt(this.content.replace(/[^0-9\.-]+/g, "", 10), 10))) {
                this.content = 0;
            }

            if (event.key == "ArrowUp" || event.key == "ArrowDown" || operator.length) {
                // Extract the current number from the content
                console.log("this.content", this.content);
                let currentNumber =
                    this.content != null && this.content
                        ? parseInt(this.content.replace(/[^0-9\.-]+/g, "", 10))
                        : parseInt(0, 10);
                console.log("currentNumber", currentNumber);

                // Update the content based on the ArrowUp key
                if (event.key == "ArrowUp" || operator == "increment") {
                    this.content = currentNumber + this.step;
                }

                // Update the content based on the ArrowDown key
                if (event.key == "ArrowDown" || operator == "decrement") {
                    this.content = currentNumber - this.step;
                }
            }

            // Convert the content to a formatted number
            this.content = this.content.toLocaleString();

            // Manually trigger a validation event for the main input's value
            this.$refs["number-input"].validate();
        },
    },
    watch: {
        value(value) {
            this.content = value;
        },
        content(value) {
            this.errorMessage = "";
            this.content = value;
            this.$emit("input", this.content);
            this.$emit("change", this.content);
        },
        error() {
            this.errorMessage = this.error;
        },
    },
};
</script>
